import InvoiceBatch from "../../entities/invoiceBatch";

/**
 * InvoiceBatch actions
 *
 * Call order:
 *
 * INVOICEBATCH_SAVE_QUEUE:	adds the item to the save queue
 * --> INVOICEBATCH_SAVE:	modifies the state
 * --> INVOICEBATCH_SAVE_SUCCESS: if all went well
 * --> INVOICEBATCH_SAVE_FAILURE:	if either the queue or local save failed
 *
 * Note that the only way to fail INVOICEBATCH_SAVE_QUEUE is during the call to INVOICEBATCH_SAVE,
 * as adding an item to the queue should never fail.
 */

export const INVOICEBATCH_FETCH_ONE_QUEUE: any = 'INVOICEBATCH_FETCH_ONE_QUEUE';
export const INVOICEBATCH_FETCH_SUCCESS: any = 'INVOICEBATCH_FETCH_SUCCESS';
export const INVOICEBATCH_FETCH_FAILURE: any = 'INVOICEBATCH_FETCH_FAILURE';
export const INVOICEBATCH_FETCH_ONE_SUCCESS: any = 'INVOICEBATCH_FETCH_ONE_SUCCESS';
export const INVOICEBATCH_FETCH_ONE_FAILURE: any = 'INVOICEBATCH_FETCH_ONE_FAILURE';

export const INVOICEBATCH_SAVE: any = 'INVOICEBATCH_SAVE';
export const INVOICEBATCH_SAVE_QUEUE: any = 'INVOICEBATCH_SAVE_QUEUE';
export const INVOICEBATCH_SAVE_SUCCESS: any = 'INVOICEBATCH_SAVE_SUCCESS';
export const INVOICEBATCH_SAVE_FAILURE: any = 'INVOICEBATCH_SAVE_FAILURE';

export const INVOICEBATCH_SAVE_MANY: any = 'INVOICEBATCH_SAVE_MANY';
export const INVOICEBATCH_SAVE_MANY_QUEUE: any = 'INVOICEBATCH_SAVE_MANY_QUEUE';
export const INVOICEBATCH_SAVE_MANY_SUCCESS: any = 'INVOICEBATCH_SAVE_MANY_SUCCESS';
export const INVOICEBATCH_SAVE_MANY_FAILURE: any = 'INVOICEBATCH_SAVE_MANY_FAILURE';

export const INVOICEBATCH_REMOVE: any = 'INVOICEBATCH_REMOVE';
export const INVOICEBATCH_REMOVE_QUEUE: any = 'INVOICEBATCH_REMOVE_QUEUE';
export const INVOICEBATCH_REMOVE_SUCCESS: any = 'INVOICEBATCH_REMOVE_SUCCESS';
export const INVOICEBATCH_REMOVE_FAILURE: any = 'INVOICEBATCH_REMOVE_FAILURE';

export const INVOICEBATCH_RESTORE: any = 'INVOICEBATCH_RESTORE';
export const INVOICEBATCH_RESTORE_QUEUE: any = 'INVOICEBATCH_RESTORE_QUEUE';
export const INVOICEBATCH_RESTORE_SUCCESS: any = 'INVOICEBATCH_RESTORE_SUCCESS';
export const INVOICEBATCH_RESTORE_FAILURE: any = 'INVOICEBATCH_RESTORE_FAILURE';

export const INVOICEBATCH_RESTORE_MANY: any = 'INVOICEBATCH_RESTORE_MANY';
export const INVOICEBATCH_REMOVE_MANY: any = 'INVOICEBATCH_REMOVE_MANY';

/* Fetch actions */
export const fetchInvoiceBatchSuccess = (invoiceBatches: InvoiceBatch[], partial: boolean, lastFetch: number) => ({type: INVOICEBATCH_FETCH_SUCCESS, invoiceBatches, partial, lastFetch});
export const fetchInvoiceBatchFailure = (err: any) => {
		console.error('InvoiceBatchAction: fetchInvoiceBatchFailure', err);
		return {type: INVOICEBATCH_FETCH_FAILURE, err};
};
export const fetchOneInvoiceBatchQueue = (invoiceBatchId: string) => ({type: INVOICEBATCH_FETCH_ONE_QUEUE, invoiceBatchId});
export const fetchOneInvoiceBatchSuccess = (invoiceBatch: InvoiceBatch) => ({type: INVOICEBATCH_FETCH_ONE_SUCCESS, invoiceBatch});
export const fetchOneInvoiceBatchFailure = (id: string, err: any) => {
		console.error('InvoiceBatchAction: fetchOneInvoiceBatchFailure', err);
		return {type: INVOICEBATCH_FETCH_ONE_FAILURE, id, err};
};

/* Save actions */
export const saveInvoiceBatch = (invoiceBatch: InvoiceBatch) => {
    // console.debug('⮂ INVOICEBATCH_SAVE action', invoiceBatch?.id);
    return {type: INVOICEBATCH_SAVE, invoiceBatch};
}
export const saveInvoiceBatchQueue = (invoiceBatch: InvoiceBatch, onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ INVOICEBATCH_SAVE_QUEUE action', invoiceBatch?.id);
    return {type: INVOICEBATCH_SAVE_QUEUE, invoiceBatch, onQueued};
}
export const saveInvoiceBatchSuccess = (invoiceBatch: InvoiceBatch) => {
    // console.debug('⮂ INVOICEBATCH_SAVE_SUCCESS action', invoiceBatch?.id);
    return {type: INVOICEBATCH_SAVE_SUCCESS, invoiceBatch};
}
export const saveInvoiceBatchFailure = (invoiceBatch: InvoiceBatch, status: number, message: string) => {
    console.warn(`⮂ INVOICEBATCH_SAVE_FAILURE error saving invoiceBatch: HTTP ${status}: ${message}`, invoiceBatch?.id);
    return {type: INVOICEBATCH_SAVE_FAILURE, invoiceBatch, status, message};
};

/* SaveMany actions */
export const saveManyInvoiceBatches = (invoiceBatches: InvoiceBatch[]) => {
    // console.debug('⮂ INVOICEBATCH_SAVE_MANY action', invoiceBatches?.map(invoiceBatch => invoiceBatch?.id).join(','));
    return {type: INVOICEBATCH_SAVE_MANY, invoiceBatches};
}
export const saveManyInvoiceBatchesQueue = (invoiceBatches: InvoiceBatch[], onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ INVOICEBATCH_SAVE_MANY_QUEUE action', invoiceBatches?.map(invoiceBatch => invoiceBatch.id).join(','));
    return {type: INVOICEBATCH_SAVE_MANY_QUEUE, invoiceBatches, onQueued};
}

export const saveManyInvoiceBatchesSuccess = (invoiceBatches: InvoiceBatch[]) => {
    // console.debug('⮂ INVOICEBATCH_SAVE_MANY_SUCCESS action', invoiceBatches?.map(invoiceBatch => invoiceBatch.id).join(','));
    return {type: INVOICEBATCH_SAVE_MANY_SUCCESS, invoiceBatches};
}
export const saveManyInvoiceBatchesFailure = (invoiceBatches: InvoiceBatch[], status: number, message: string) => {
		console.warn(`⮂ SAVE_MANY_INVOICEBATCHES_FAILURE Error saving invoiceBatches: HTTP ${status}: ${message}`, invoiceBatches?.map(invoiceBatch => invoiceBatch.id).join(','));
		return {type: INVOICEBATCH_SAVE_MANY_FAILURE, invoiceBatches, status, message};
};

/* Remove actions */
export const removeInvoiceBatch = (invoiceBatch: InvoiceBatch) => ({ type: INVOICEBATCH_REMOVE, invoiceBatch });
export const removeInvoiceBatchQueue = (invoiceBatch: InvoiceBatch) => ({ type: INVOICEBATCH_REMOVE_QUEUE, invoiceBatch });
export const removeInvoiceBatchSuccess = (invoiceBatch: InvoiceBatch) => ({ type: INVOICEBATCH_REMOVE_SUCCESS, invoiceBatch });
export const removeInvoiceBatchFailure = (invoiceBatch: InvoiceBatch, status: number, message: string) => {
	console.error(`Redux: removeInvoiceBatchFailure Error removing invoiceBatch: HTTP ${status}: ${message}`);
	return ({ type: INVOICEBATCH_REMOVE_FAILURE, invoiceBatch, status, message });
};

/* Restore actions */
export const restoreInvoiceBatch = (invoiceBatch: InvoiceBatch) => ({ type: INVOICEBATCH_RESTORE, invoiceBatch });
export const restoreInvoiceBatchQueue = (invoiceBatch: InvoiceBatch) => ({ type: INVOICEBATCH_RESTORE_QUEUE, invoiceBatch });
export const restoreInvoiceBatchSuccess = (invoiceBatch: InvoiceBatch) => ({ type: INVOICEBATCH_RESTORE_SUCCESS, invoiceBatch });
export const restoreInvoiceBatchFailure = (invoiceBatch: InvoiceBatch, status: number, message: string) => {
	console.error(`Redux: restoreInvoiceBatchFailure Error restoring invoiceBatch: HTTP ${status}: ${message}`);
	return ({ type: INVOICEBATCH_RESTORE_FAILURE, invoiceBatch, status, message });
};

/* RestoreMany actions */
export const restoreManyInvoiceBatches = (invoiceBatches: InvoiceBatch[]) => ({ type: INVOICEBATCH_RESTORE_MANY, invoiceBatches });

/* RemoveMany actions */
export const removeManyInvoiceBatches = (invoiceBatches: InvoiceBatch[]) => ({ type: INVOICEBATCH_REMOVE_MANY, invoiceBatches });